import { render, staticRenderFns } from "./board-form.vue?vue&type=template&id=f5f33a94"
import script from "./board-form.vue?vue&type=script&lang=ts"
export * from "./board-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports